import React, { useMemo, useState } from "react";
import {
  Envelope,
  GeoAlt,
  Telephone,
  GearFill,
  XLg,
} from "react-bootstrap-icons";
import Counsellorroom from "../assets/CounsellorConcept.png";
import CounsellorProfileFemale from "../assets/CounsellorProfileFemale.png";
import CounsellorProfileMale from "../assets/CounsellorProfileMale.png";
import { useNavigate, useParams } from "react-router-dom";
import balance from "../assets/heros/balance.png";
import beach from "../assets/heros/beach.png";
import calmradiance from "../assets/heros/calmradiance.png";
import forrest from "../assets/heros/forrest.png";
import landscape from "../assets/heros/landscape.png";
import quietroom from "../assets/heros/quietroom.png";
import river from "../assets/heros/river.png";
import room from "../assets/heros/room.png";
import window from "../assets/heros/window.png";
import "./CounsellingConcept.css";

export default function CounsellingConcept() {
  const { id } = useParams();
  const navi = useNavigate();
  const [heroBg, setHeroBg] = useState(balance);
  const [websiteType, setWebsiteType] = useState("one-page");
  const [styleMenuOpen, setStyleMenuOpen] = useState(false);

  const handleWebsiteTypeChange = (value) => {
    setWebsiteType(value);

    if (value === "one-page") {
      navi(`/counselling-concept/${id}`);
    }

    if (value === "multi-page") {
      navi(`/counselling-concept-two/${id}`);
    }

    if (value === "hybrid") {
      navi(`/counselling-concept-three/${id}`);
    }
  };

  const profileImage =
    id === "1" ? CounsellorProfileFemale : CounsellorProfileMale;

  const heroSection = {
    backgroundImage: `url(${heroBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  const palettes = useMemo(
    () => [
      {
        id: "warm",
        name: "Warm neutral",
        background: "#F7F3EE",
        surface: "#FFFFFF",
        section: "#F3EADF",
        text: "#1F2B2A",
        muted: "#5F6D6A",
        brand: "#6B7C75",
        brandHover: "#5E6E68",
        border: "#E4DAD0",
        footer: "#1E2322",
      },
      {
        id: "sage",
        name: "Sage and cream",
        background: "#F6F8F6",
        surface: "#FFFFFF",
        section: "#EEF3EF",
        text: "#1F2B2A",
        muted: "#5E6B65",
        brand: "#4F6F63",
        brandHover: "#436056",
        border: "#DDE6E1",
        footer: "#1B2321",
      },
      {
        id: "bluegrey",
        name: "Soft blue grey",
        background: "#F5F7FA",
        surface: "#FFFFFF",
        section: "#EEF2F6",
        text: "#1E2A33",
        muted: "#576574",
        brand: "#4C6475",
        brandHover: "#415868",
        border: "#DCE3EA",
        footer: "#1B232B",
      },
      {
        id: "rose",
        name: "Dusty rose",
        background: "#FAF6F7",
        surface: "#FFFFFF",
        section: "#F4EAEC",
        text: "#2B1F24",
        muted: "#6D5B62",
        brand: "#7A5A66",
        brandHover: "#6B4E59",
        border: "#E7D7DD",
        footer: "#241A1F",
      },
      {
        id: "deepgreen",
        name: "Deep calm green",
        background: "#F6F7F6",
        surface: "#FFFFFF",
        section: "#EDEFEA",
        text: "#172423",
        muted: "#556360",
        brand: "#2F5D50",
        brandHover: "#284F45",
        border: "#D9DED7",
        footer: "#0F1E1B",
      },
      {
        id: "mono",
        name: "Minimal warm",
        background: "#F7F7F5",
        surface: "#FFFFFF",
        section: "#F0EEE9",
        text: "#1D1D1B",
        muted: "#5F5F59",
        brand: "#3E3E3A",
        brandHover: "#2F2F2C",
        border: "#E3E1DA",
        footer: "#1A1A18",
      },
    ],
    []
  );

  const [paletteId, setPaletteId] = useState("warm");
  const palette = palettes.find((x) => x.id === paletteId) || palettes[0];

  const [hoverPrimary, setHoverPrimary] = useState(false);
  const [hoverSecondary, setHoverSecondary] = useState(false);

  const page = {
    minHeight: "100vh",
    background: palette.background,
    color: palette.text,
  };

  const beige = { background: palette.section };

  const softCard = {
    border: "0",
    borderRadius: "18px",
    boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
    background: palette.surface,
  };

  const translucentPanel = {
    background: "rgba(255, 255, 255, 0.4)",
    borderRadius: "18px",
    border: `1px solid ${palette.border}`,
    marginTop: "30px",
    marginBottom: "50px",
  };

  const softPanel = {
    borderRadius: "18px",
    border: `1px solid ${palette.border}`,
    background: palette.surface,
  };

  const pill = {
    display: "inline-block",
    padding: "6px 12px",
    borderRadius: "999px",
    background: palette.surface,
    border: `1px solid ${palette.border}`,
    fontSize: "13px",
    color: palette.muted,
  };

  const brandButtonBase = {
    borderRadius: "12px",
    padding: "12px 26px",
    fontWeight: 600,
    textDecoration: "none",
    display: "inline-block",
    lineHeight: 1.2,
  };

  const brandButton = {
    ...brandButtonBase,
    background: hoverPrimary ? palette.brandHover : palette.brand,
    border: `1px solid ${hoverPrimary ? palette.brandHover : palette.brand}`,
    color: palette.surface,
  };

  const brandButtonOutline = {
    ...brandButtonBase,
    background: hoverSecondary ? palette.brand : "transparent",
    border: `1px solid ${palette.brand}`,
    color: hoverSecondary ? palette.surface : palette.brand,
  };

  const imageWrap = {
    borderRadius: "18px",
    overflow: "hidden",
    border: `1px solid ${palette.border}`,
    background: palette.surface,
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    display: "block",
    objectFit: "cover",
  };

  return (
    <div style={page}>
      <div
        style={{
          position: "fixed",
          top: "100px",
          left: "16px",
          zIndex: 1050,
        }}
      >
        {!styleMenuOpen && (
          <button
            type="button"
            onClick={() => setStyleMenuOpen(true)}
            aria-label="Open style menu"
            style={{
              width: "44px",
              height: "44px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: palette.surface,
              border: `1px solid ${palette.border}`,
              borderRadius: "14px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
              color: palette.text,
            }}
          >
            <GearFill size={18} />
          </button>
        )}

        {styleMenuOpen && (
          <div
            style={{
              background: palette.surface,
              border: `1px solid ${palette.border}`,
              borderRadius: "14px",
              padding: "10px 12px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
              width: "220px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: palette.muted,
                }}
              >
                Change style
              </div>

              <button
                type="button"
                onClick={() => setStyleMenuOpen(false)}
                aria-label="Close style menu"
                style={{
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "transparent",
                  border: `1px solid ${palette.border}`,
                  borderRadius: "10px",
                  color: palette.muted,
                }}
              >
                <XLg size={16} />
              </button>
            </div>

            <select
              className="form-select form-select-sm"
              value={paletteId}
              onChange={(e) => setPaletteId(e.target.value)}
              style={{
                width: "100%",
                borderColor: palette.border,
                color: palette.text,
                backgroundColor: palette.surface,
                fontSize: "14px",
              }}
            >
              {palettes.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>

            <div className="mt-2">
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  marginBottom: "6px",
                  color: palette.muted,
                }}
              >
                Change Image
              </div>

              <select
                className="form-select form-select-sm"
                value={heroBg}
                onChange={(e) => setHeroBg(e.target.value)}
                style={{
                  width: "100%",
                  borderColor: palette.border,
                  color: palette.text,
                  backgroundColor: palette.surface,
                  fontSize: "14px",
                }}
              >
                <option value={balance}>Balance</option>
                <option value={beach}>Beach</option>
                <option value={calmradiance}>Calm radiance</option>
                <option value={forrest}>Forrest</option>
                <option value={landscape}>Landscape</option>
                <option value={quietroom}>Quiet room</option>
                <option value={river}>River</option>
                <option value={room}>Room</option>
                <option value={window}>Window</option>
              </select>
            </div>

            <div className="mt-2">
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  marginBottom: "6px",
                  color: palette.muted,
                }}
              >
                Website type
              </div>

              <select
                className="form-select form-select-sm"
                value={websiteType}
                onChange={(e) => handleWebsiteTypeChange(e.target.value)}
                style={{
                  width: "100%",
                  borderColor: palette.border,
                  color: palette.text,
                  backgroundColor: palette.surface,
                  fontSize: "14px",
                }}
              >
                <option value="one-page">One page</option>
                <option value="multi-page">Multi page</option>
                <option value="hybrid">Hybrid</option>
              </select>
            </div>
          </div>
        )}
      </div>

      <nav
        className="navbar navbar-expand-lg"
        style={{
          background: palette.surface,
          borderBottom: `1px solid ${palette.border}`,
        }}
      >
        <div className="container py-2">
          <a
            className="navbar-brand fw-bold"
            href="#home"
            style={{ color: palette.text }}
          >
            Counselling Practice
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#about" style={{ color: palette.text }}>
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services" style={{ color: palette.text }}>
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#approach" style={{ color: palette.text }}>
                  Approach
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#pricing" style={{ color: palette.text }}>
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact" style={{ color: palette.text }}>
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <section id="home" style={heroSection}>
        <div className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">
                <div className="p-4 p-md-5" style={translucentPanel}>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <span style={pill}>Confidential</span>
                    <span style={pill}>Supportive</span>
                    <span style={pill}>Online or in person</span>
                  </div>

                  <h1
                    className="fw-bold mb-2"
                    style={{
                      fontSize: "42px",
                      lineHeight: 1.15,
                      color: palette.text,
                    }}
                  >
                    A calm space to talk things through
                  </h1>

                  <p
                    className="mb-4"
                    style={{
                      maxWidth: "820px",
                      color: palette.muted,
                      fontSize: "18px",
                      lineHeight: 1.7,
                    }}
                  >
                    A counselling website concept focused on warmth, clarity,
                    and simplicity. Designed to explain what is offered and make
                    getting in touch feel easy.
                  </p>

                  <div className="d-flex flex-wrap gap-3">
                    <a
                      href="#contact"
                      style={brandButton}
                      onMouseEnter={() => setHoverPrimary(true)}
                      onMouseLeave={() => setHoverPrimary(false)}
                    >
                      Make an enquiry
                    </a>

                    <a
                      href="#services"
                      style={brandButtonOutline}
                      onMouseEnter={() => setHoverSecondary(true)}
                      onMouseLeave={() => setHoverSecondary(false)}
                    >
                      View services
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="py-5" style={beige}>
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-lg-5">
              <div style={imageWrap}>
                <img
                  src={profileImage}
                  alt="Counsellor profile"
                  style={{ ...imageStyle, minHeight: "320px" }}
                  loading="lazy"
                />
              </div>
            </div>

            <div className="col-12 col-lg-7">
              <h2 className="fw-bold mb-3" style={{ color: palette.text }}>
                About
              </h2>
              <div className="p-4" style={softPanel}>
                <p className="mb-3" style={{ color: palette.muted, lineHeight: 1.8 }}>
                  This section introduces the counsellor and explains how
                  sessions tend to work, in a clear and welcoming way.
                </p>
                <ul className="mb-0" style={{ color: palette.muted, lineHeight: 1.8 }}>
                  <li>Qualifications and memberships</li>
                  <li>Areas of focus and experience</li>
                  <li>Ongoing training and supervision</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="py-5" style={{ background: palette.surface }}>
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-lg-6">
              <h2 className="fw-bold mb-3" style={{ color: palette.text }}>
                Services
              </h2>
              <p className="mb-4" style={{ color: palette.muted, lineHeight: 1.8 }}>
                A simple overview of what is offered and who it may be helpful
                for.
              </p>

              <div className="row g-3">
                {[
                  {
                    t: "Individual counselling",
                    d: "One to one sessions to explore what is going on and what you want to change.",
                  },
                  {
                    t: "Support with stress and worry",
                    d: "Practical tools and a calmer understanding of patterns and triggers.",
                  },
                  {
                    t: "Relationship support",
                    d: "Help with boundaries, communication, and repeating difficulties.",
                  },
                ].map((x) => (
                  <div key={x.t} className="col-12">
                    <div className="p-4" style={softPanel}>
                      <div className="fw-bold mb-1" style={{ color: palette.text }}>
                        {x.t}
                      </div>
                      <div style={{ color: palette.muted, lineHeight: 1.8 }}>{x.d}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div style={imageWrap}>
                <img
                  src={Counsellorroom}
                  alt="Counselling room"
                  style={{ ...imageStyle, minHeight: "340px" }}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="approach" className="py-5" style={beige}>
        <div className="container">
          <h2 className="fw-bold mb-3" style={{ color: palette.text }}>
            Approach
          </h2>
          <div className="p-4" style={softPanel}>
            <p className="mb-0" style={{ color: palette.muted, lineHeight: 1.8 }}>
              Explain the approach in plain language. Keep it simple and
              reassuring, focused on collaboration, pacing, and practical
              support.
            </p>
          </div>
        </div>
      </section>

      <section id="pricing" className="py-5" style={{ background: palette.surface }}>
        <div className="container">
          <h2 className="fw-bold mb-3" style={{ color: palette.text }}>
            Pricing
          </h2>

          <div className="row g-3">
            <div className="col-12 col-lg-6">
              <div className="p-4" style={softCard}>
                <div style={{ color: palette.muted, marginBottom: "6px" }}>
                  Session fee
                </div>
                <div className="fw-bold" style={{ fontSize: "28px", color: palette.brand }}>
                  £50 per session
                </div>
                <div style={{ color: palette.muted, marginTop: "10px", lineHeight: 1.8 }}>
                  Add a short note about length and any options you offer.
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="p-4" style={softPanel}>
                <div className="fw-bold mb-1" style={{ color: palette.text }}>
                  What is included
                </div>
                <ul className="mb-0" style={{ color: palette.muted, lineHeight: 1.8 }}>
                  <li>Regular sessions</li>
                  <li>Online or in person options</li>
                  <li>Review and adjust as needed</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="py-5" style={beige}>
        <div className="container">
          <h2 className="fw-bold mb-3" style={{ color: palette.text }}>
            Contact
          </h2>

          <div className="row g-3">
            <div className="col-12 col-lg-6">
              <div className="p-4" style={softPanel}>
                <p className="mb-3" style={{ color: palette.muted, lineHeight: 1.8 }}>
                  Add your preferred contact method and what happens next.
                </p>

                <p className="mb-2 d-flex align-items-center" style={{ color: palette.text }}>
                  <Telephone className="me-2" size={20} style={{ color: palette.muted }} />{" "}
                  07XXX XXXXXX
                </p>

                <p className="mb-2 d-flex align-items-center" style={{ color: palette.text }}>
                  <Envelope className="me-2" size={20} style={{ color: palette.muted }} />{" "}
                  example@email.com
                </p>

                <p className="mb-0 d-flex align-items-center" style={{ color: palette.text }}>
                  <GeoAlt className="me-2" size={20} style={{ color: palette.muted }} />{" "}
                  City, County
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="p-4" style={softPanel}>
                <div className="fw-bold mb-2" style={{ color: palette.text }}>
                  Enquiry placeholder
                </div>
                <div className="mb-3" style={{ color: palette.muted, lineHeight: 1.8 }}>
                  Replace with a form or booking system when ready.
                </div>

                <div className="d-grid gap-2">
                  <button
                    type="button"
                    style={{
                      ...brandButtonBase,
                      background: hoverPrimary ? palette.brandHover : palette.brand,
                      border: `1px solid ${hoverPrimary ? palette.brandHover : palette.brand}`,
                      color: palette.surface,
                    }}
                    onMouseEnter={() => setHoverPrimary(true)}
                    onMouseLeave={() => setHoverPrimary(false)}
                  >
                    Request an appointment
                  </button>

                  <button
                    type="button"
                    style={{
                      ...brandButtonBase,
                      background: hoverSecondary ? palette.brand : "transparent",
                      border: `1px solid ${palette.brand}`,
                      color: hoverSecondary ? palette.surface : palette.brand,
                    }}
                    onMouseEnter={() => setHoverSecondary(true)}
                    onMouseLeave={() => setHoverSecondary(false)}
                  >
                    Ask a question
                  </button>
                </div>

                <div className="mt-3" style={{ color: palette.muted, fontSize: "13px" }}>
                  Typical reply time within 24 to 48 hours
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="py-5" style={{ background: palette.footer, color: palette.surface }}>
        <div className="container text-center">
          <div className="fw-bold mb-1">Counselling Practice</div>
          <div className="small">© {new Date().getFullYear()} Counselling Practice</div>
        </div>
      </footer>
    </div>
  );
}
